export default __webpack_public_path__ + "static/media/img-4.36fd4299.jpg";